import { useQuery } from '@tanstack/react-query';
import { getBlueprints } from '../blueprint';

export function useBlueprints() {
  return useQuery({
    queryKey: ['blueprints'],
    queryFn: () => getBlueprints(),
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}